import * as React from 'react';
import { SelectionCard } from '../../molecules/selection-card/selection-card';
import { SelectionCardSizeEnum, SelectionCardVariantEnum } from '../../molecules/selection-card/selection-card.type';
import { Dialog } from '../dialog/dialog';
import { DialogPrimaryLayout } from '../dialog/layouts/dialog-primary-layout';
import type { ISelectionCardsDialogProps } from './selection-cards-dialog.type';
import { cn } from '@utils';

export const SelectionCardsDialog = <T extends string>({
	open,
	onOpenChange,
	title,
	description,
	options,
	onSelect,
	cancelLabel,
	onCancel,
	selectedValue = null,
	cardSize = SelectionCardSizeEnum.MD,
	cardVariant = SelectionCardVariantEnum.OUTLINED,
	cardAlignment,
	className,
	testId = 'selection-cards-dialog',
}: ISelectionCardsDialogProps<T>): React.ReactElement => {
	const handleCancel = (): void => {
		onCancel?.();
		onOpenChange(false);
	};

	const handleSelect = (value: T): void => {
		onSelect(value);
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogPrimaryLayout
				title={title}
				description={description}
				secondaryButton={cancelLabel}
				onSecondaryAction={handleCancel}
				className={cn('w-fit max-w-[90vw]', className)}
				data-testid={testId}
				buttonsContainerClassName="ml-auto"
				{...(description ? {} : { 'aria-describedby': undefined })}
			>
				<div className="flex w-max max-w-[min(68rem,calc(90vw-5rem))] flex-wrap justify-center gap-5">
					{options.map(option => (
						<SelectionCard
							key={option.value}
							label={option.label}
							description={option.description}
							icon={option.icon}
							disabled={option.disabled}
							isSelected={selectedValue === option.value}
							size={cardSize}
							variant={cardVariant}
							alignment={cardAlignment}
							onClick={() => handleSelect(option.value)}
							testId={option.testId ?? `${testId}-card-${option.value}`}
						/>
					))}
				</div>
			</DialogPrimaryLayout>
		</Dialog>
	);
};
